import { SVGProps } from 'react'

export const FavouritesIcon = (props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.9945 6.67663C10.395 4.84174 7.7278 4.34816 5.72376 6.02837C3.71972 7.70858 3.43757 10.5178 5.01136 12.505C6.31985 14.1572 10.2798 17.6419 11.5777 18.7697C11.7229 18.8959 11.7955 18.959 11.8802 18.9838C11.9541 19.0054 12.035 19.0054 12.1089 18.9838C12.1936 18.959 12.2662 18.8959 12.4114 18.7697C13.7092 17.6419 17.6692 14.1572 18.9777 12.505C20.5515 10.5178 20.3038 7.69091 18.2653 6.02837C16.2268 4.36584 13.594 4.84174 11.9945 6.67663Z"
				stroke="white"
				strokeWidth="1.8"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}
